import React from 'react';
import T from '../../common/components/T';
import { generateUniqueId } from '../../common/utils/utils';

export const getSteps = () => {
    return [
        {
            title: <T textName='step-1-title' defaultStr='Основные данные' page='/store/register' />,
            subtitle: (
                <T textName='step-1-subtitle' defaultStr='Укажите данные спонсора и нового пользователя' page='/store/register' />
            )
        },
        {
            title: <T textName='step-2-title_n' defaultStr='Активация аккаунта' page='/store/register' />,
            subtitle: [
                // <React.Fragment key={generateUniqueId()}>
                //     <T
                //         textName='step-2-subtitle-1'
                //         defaultStr='Для продолжения регистрации необходимо активировать аккаунт'
                //         page='/store/register'
                //     />
                //     .
                // </React.Fragment>,
                <T
                    textName='step-2-subtitle-2-v2'
                    defaultStr='Выберите комплект или товары'
                    page='/store/register'
                    key={generateUniqueId()}
                />
            ]
        },
        {
            title: <T textName='step-3-title' defaultStr='Оформление заказа' page='/store/register' />
            // subtitle: <T textName='step-3-subtitle' defaultStr='После подтверждения заказа, новый пользователь будет зарегистрирован в вашей структуре' page='/store/register' />
        }
    ];
};
